import React from 'react'

import './styles.scss'
import { lang } from 'utils/helpers'
import Nixi1Spinner from 'components/Nixi1Spinner'

const SquareNavbar = ({ className, items = [], count, countLoading, value = '', onChange }) => {
  const activeTab = value || items[0]?.type || ''

  return (
    <ul className={`square-navbar ${className || ''}`}>
      {items.map((item, index) => (
        <li key={index} className='square-navbar__tab'>
          <button
            className={`
              square-navbar__tab-btn
              ${activeTab === item.type ? 'square-navbar__tab-btn--active' : ''}
            `}
            onClick={() => onChange(item.type)}
          >
            <figure className='square-navbar__icon'>
              <img
                src={activeTab === item.type ? item.activeIconUrl : item.iconUrl}
                alt={lang(item.title)}
              />
            </figure>
            <strong className='square-navbar__title'>{lang(item.title)}</strong>
            {(item.count || (activeTab === item.type && count.value >= 0)) ? (
              (!countLoading || item.count) ? (
                <span className='square-navbar__count'>{item.count || count.value}</span>
              ) : (
                <Nixi1Spinner width='10px' height='10px' />
              )
            ) : null}
          </button>
        </li>
      ))}
    </ul>
  )
}

export default SquareNavbar
